import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { AdminService } from 'src/app/admin/admin.service';
import { ThemeCustomizerService } from 'src/app/components/common/theme-customizer/theme-customizer.service';
import { PublicServiceService } from 'src/app/public-service.service';
import { getImgeUrl } from 'src/environments/environment';
@Component({
  selector: 'app-project-details',
  standalone: true,
  imports: [CommonModule, RouterLink],
  templateUrl: './project-details.component.html',
  styleUrl: './project-details.component.scss'
})
export class ProjectDetailsComponent {

  isToggled = false;
  id
  project
  imageURL = getImgeUrl()
  constructor(
    public themeService: ThemeCustomizerService, 
    private activeRouter: ActivatedRoute, 
    private publicService: PublicServiceService, 
  ) {
      this.themeService.isToggled$.subscribe(isToggled => {
          this.isToggled = isToggled;
      });
  }

  toggleTheme() {
      this.themeService.toggleTheme();
  }

  ngOnInit(): void {
    this.id = this.activeRouter.snapshot.params["id"]
    this.getDat()
  }

  getDat() {
    this.publicService.getRecordById(this.publicService.PROJECTS_URL, this.id).subscribe({
      next: (res) => {
        this.project = res
      },
      error: (err) => {
        console.log(err)
      }
    })
  }

}
